import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// Enum for sidebar types
export type RightSidebarType = 'none' | 'chat' | 'assistant';

// Active sidebar type (starts closed on every page load)
export const $rightSidebarType = atom<RightSidebarType>('none');

// Shared width for all sidebar types (persisted to localStorage)
// Both chat and assistant use the same width (in pixels)
export const $rightSidebarWidth = atomWithStorage<number>(
  'right-sidebar-width',
  600, // Default 600px for both chat and assistant
);

export const $isRightSidebarOpen = atom(
  (get) => get($rightSidebarType) !== 'none',
);
